import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/brave_bites_new_logo.png'


const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "nav-content" }
const _hoisted_3 = { class: "nav-links" }

import { RouterLink, useRouter } from 'vue-router';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { ref, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Nav',
  setup(__props) {

const auth = getAuth();
const router = useRouter();
const isLoggedIn = ref(false);
const isMenuOpen = ref(false); // NEW

onMounted(() => {
  onAuthStateChanged(auth, (user) => {
    isLoggedIn.value = !!user;
  });
});

const openNavMenu = () => {
  isMenuOpen.value = true;
};

const closeNavMenu = () => {
  isMenuOpen.value = false;
};

const logout = async () => {
  try {
    await signOut(auth);
    router.push('/login');
  } catch (error) {
    console.error("Logout failed", error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "nav-logo-container" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Brave Bites Logo"
        })
      ], -1)),
      _createElementVNode("button", {
        class: "open_nav_menu_button button",
        onClick: openNavMenu
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'bars'],
          class: "fa-xl"
        })
      ])
    ]),
    (isMenuOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "overlay",
          onClick: closeNavMenu
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['side-menu', { 'open': isMenuOpen.value }])
    }, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "side-menu-branding" }, [
        _createElementVNode("img", { src: _imports_0 }),
        _createElementVNode("p", null, "Brave Bites")
      ], -1)),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", null, [
          _createVNode(_unref(RouterLink), {
            to: "/home/",
            class: "button back",
            onClick: closeNavMenu
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                class: "fa-lg",
                icon: ['fas', 'house']
              }),
              _cache[1] || (_cache[1] = _createElementVNode("p", null, "Home", -1))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_unref(RouterLink), {
            to: "/list/",
            class: "button back",
            onClick: closeNavMenu
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                class: "fa-lg",
                icon: ['fas', 'bowl-food']
              }),
              _cache[2] || (_cache[2] = _createElementVNode("p", null, "Dishlist", -1))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_unref(RouterLink), {
            to: "/report/",
            class: "button back",
            onClick: closeNavMenu
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                class: "fa-lg",
                icon: ['fas', 'file']
              }),
              _cache[3] || (_cache[3] = _createElementVNode("p", null, "Report", -1))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_unref(RouterLink), {
            to: "/profile/",
            class: "button back",
            onClick: closeNavMenu
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                class: "fa-lg",
                icon: ['fas', 'user']
              }),
              _cache[4] || (_cache[4] = _createElementVNode("p", null, "Profile", -1))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("button", {
        class: "button primary logout-link",
        onClick: logout
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'right-from-bracket'],
          class: "fa-xl"
        }),
        _cache[5] || (_cache[5] = _createElementVNode("p", null, "Logout", -1))
      ])
    ], 2)
  ]))
}
}

})